export default __webpack_public_path__ + "emptyZmlDropImg.svg";